import Harrison2 from '../../pages/harrison2/Harrison2'

import PrefixEnum from '../prefixes'

export default Object.freeze([
    { path: PrefixEnum.HARRISON2, component: Harrison2 },
])
